module.exports = __webpack_public_path__ + "img/astronomers_4.2a03be95.jpg";